
const initialState = {
  roundId: null, // this will store the current roundId
  events:{},
};

const roundReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ROUND_ID":
      return {
        ...state,
        roundId: action.payload,
      };
      case 'SET_ROUND_FOR_EVENT':
        return {
          ...state,
          events: {
            ...state.events,
            [action.payload.eventId]: action.payload.roundId,
          },
        };
    default:
      return state;
  }
};

export default roundReducer;
